import { Resource } from "../../types/resource";
import { useResourceContext } from "../../contexts/ResourceContext";
import { getResourceIcon } from "../../Data/IconData";
import '../../Styles/Layout/Resources/ResourceListItem.css';
import { useAttachmentContext } from '../../contexts/AttachmentContext';

interface ResourceListItemProps {
  resource: Resource;
}

export const ResourceListItem: React.FC<ResourceListItemProps> = ({ resource }) => {
  const { currentChatResources, handleResourceClick, expandedResource } = useResourceContext();
  const { isTextAttachmentViewOpen, handleTextAttachmentViewClose } = useAttachmentContext();

  const versionCount = currentChatResources.filter(
    r => (r.title || 'Resource Title') === (resource.title || 'Resource Title')
  ).length;
  const isActive = !isTextAttachmentViewOpen && expandedResource?.title === resource.title;
  const displayTitle = resource.title || 'Resource Title';

  return (
    <button
      className={`rli${isActive ? ' rli--active' : ''}`}
      onClick={() => {
        if (isTextAttachmentViewOpen) handleTextAttachmentViewClose();
        handleResourceClick(resource.title, resource.messageId || '');
      }}
    >
      <span className="rli-icon">{getResourceIcon(resource.type)}</span>
      <span className="rli-title" title={displayTitle}>{displayTitle}</span>
      {versionCount > 1 && (
        <span className="rli-badge">{versionCount}</span>
      )}
    </button>
  );
};
